// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"09604405","585":"bbb6ca8c"}[chunkId] + ".chunk.js";
};